import { TMeta } from './models';

const VALID_STATUS = undefined;

export const isSuccess = ({
    dirtySinceLastSubmit,
    error,
    submitError,
    submitSucceeded,
    submitting,
    touched,
}: TMeta) => {
    /**
     * При отправке формы React Final Form аннулирует
     * свойство touched, что может приводить к
     * незапланированной смене success-статуса, поэтому
     * если поле было отправлено, то мы это расцениваем
     * равнозначно touched, чтоб не вводить пользователя
     * в заблуждение
     */
    const submitted = submitSucceeded || submitting;

    if (!touched && !submitted) return VALID_STATUS;
    if (error) return false;
    if (submitError) return dirtySinceLastSubmit;

    return true;
};
